import Vue from 'vue';
import moment from 'moment';

const filters = {
  formatNum(inputValue) {
    if (parseFloat(inputValue) !== inputValue
      || !inputValue
      || Number.isNaN(inputValue)) {
      return inputValue;
    }
    const [integer, decimal] = String(inputValue).split('.');
    if (integer.length <= 3) {
      return inputValue;
    }
    const result = [];
    const integerArr = integer.split('').reverse();
    integerArr.forEach((item, index) => {
      result.push(item);
      if ((index + 1) % 3 === 0 && [0, integer.length - 1].indexOf(index) === -1) {
        result.push(',');
      }
    });
    return `${result.reverse().join('')}${decimal ? `.${decimal}` : ''}`;
  },
  formatDate(inputValue, type) {
    return moment(inputValue).format(type);
  },
  filterListValue(inputValue, list, key, name) {
    const result = list.find((item) => item[key] === inputValue);
    return result ? result[name] : '';
  },
  formatTextWithLink(inputValue) {
    inputValue = inputValue.replace(/\^\{.*?\}/g, function(src) {
      return '<span class="text-emphasize">' + src.substring(2, src.length - 1) + '</span>';
    });
    inputValue = inputValue.replace(/\~\{.*?\}\{.*?\}/g, function(src) {
      const [text, link] = src.substring(2, src.length - 1).split('}{');
      return '<span class="text-link" onclick="handleGoTo(\'' + link + '\')">' + text + '</span>';
    });
    return inputValue;
  }
};

Object.keys(filters).forEach((filter) => {
  Vue.filter(filter, filters[filter]);
});
